import { useMutation } from "@apollo/client/react";import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";

import SAVE_VISITA_TELE_ENFERMERIA_CP, { adaptAddVisitaTeleEnfermeriaCPInput } from "../../../../../../data/graphQL/mutations/Visitas/saveControlSintomas";
import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function ControlSintomas({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_VISITA_TELE_ENFERMERIA_CP);

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };
      if (readOnly) newInput.disabled = true;

      switch (input.name) {
        case "obsCatarsis":
          newInput.required = formData.catarsis === false;
          break;
        case "cantidad":
          if (formData.diuresis === false) handleChange("cantidad", null);
          newInput.disabled = formData.diuresis !== true;
          break;
        case "obsDiuresis":
          if (formData.diuresis === false) handleChange("obsDiuresis", null);
          newInput.disabled = formData.diuresis !== false;
          break;
        default:
          break;
      }

      if (esUrgencia) newInput.required = false;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });
  }, [formData.catarsis, formData.diuresis, readOnly, esUrgencia]);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { input: adaptAddVisitaTeleEnfermeriaCPInput(formData) } });

    const idTeleEnfermeriaCPNueva = data?.saveVisitaTeleEnfermeriaCP?.idTeleEnfermeriaCP;
    if (!idTeleEnfermeriaCPNueva) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idTeleEnfermeriaCP: idTeleEnfermeriaCPNueva
    }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'controlSintomas',
      stepName: 'Control de síntomas',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
      <Grid container spacing={2}>
        {formattedInputs.map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
            <RenderInputByTypeMobile
            input={input}
            value={formData[input.name]}
            handleChange={handleChange} />
          
          </Grid>
        )}
      </Grid>
    </CardBox>);

}

const inputs = [
{
  name: "apetito",
  displayName: "¿Se encuentra usted con apetito?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "gradoDolor",
  displayName:
  "¿Qué grado de Dolor tiene de 1 a 10?",
  type: "int",
  required: true,
  min: 1,
  max: 10
},
{
  name: "catarsis",
  displayName: "Catarsis",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "obsCatarsis",
  displayName: "Obs. Catarsis",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "diuresis",
  displayName: "Diuresis",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "cantidad",
  displayName: "Cantidad (ml)",
  type: "int",
  required: true
},
{
  name: "obsDiuresis",
  displayName: "Obs. Diuresis",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "horaCama",
  displayName: "¿Cuántas horas pasa en la cama?",
  type: "int",
  required: true
}];